import { configureStore } from '@reduxjs/toolkit';
import statesReducer from './features/statesSlice';

export const store = configureStore({
  reducer: {
    states: statesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 